import type { SVGProps } from "react";
const SvgImpactLevel1 = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M22.291 7.686c-1.52 1.07-3.007 2.125-4.505 3.164-.362.251-.604.527-.746.968-1.464 4.526-6.4 6.333-10.841 4.003-1.99-1.044-3.48-2.586-4.78-4.489 1.991.724 3.492-.3 5.039-1.11 1.283-.671 2.504-1.459 3.856-2.001 1.904-.765 3.783-1.04 5.523.403.1.082.185.18.288.258.373.279.32.481-.04.768-2.489 1.977-5.355 3.026-8.522 3.365l-.333.035c.203.281.491.19.736.21 3.143.239 5.897-.805 8.466-2.45 1.385-.889 2.662-1.915 3.934-2.947.8-.649.8-.649 1.925-.177"
        />
    </svg>
);
export default SvgImpactLevel1;
